import script from "./TopNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavBar.vue?vue&type=script&setup=true&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=2828c489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2828c489"]])

export default __exports__